import { getName } from "js/formatting";

import CardWithFields from "components/General/CardWithFields";
import CardDisclaimerBase from "components/General/CardDisclaimerBase";
import { useTranslation } from "react-i18next";

export default function DeprecatedInsuredCard({ insureds, policyDetail }) {
  const { t } = useTranslation();
  const primaryInsureds = insureds.filter(
    (insured) => insured.person.partyTypeCode === "IN"
  );
  return (
    <CardWithFields
      ariaLabel={t("AgentDeprecatedInsuredCard-label")}
      cardTitle={t("AgentDeprecatedInsuredCard-card-title")}
      cardFields={[
        {
          title: t("AgentDeprecatedInsuredCard-title-1"),
          value: insureds.map((insured, idx) => (
            <p key={`insured name - ${idx}`}>
              {getName(insured.person)}
              <br />
            </p>
          )),
        },
        {
          title: t("AgentDeprecatedInsuredCard-title-2"),
          value: insureds.map((insured, idx) => (
            <p key={`insured dob - ${idx}`}>
              {insured.person.dateofBirth}
              <br />
            </p>
          )),
        },
        ...(primaryInsureds.length > 0
          ? [
              {
                title: t("AgentDeprecatedInsuredCard-title-3"),
                value: primaryInsureds.map((insured, idx) => (
                  <p key={`insured issue age - ${idx}`}>
                    {policyDetail?.insuredIssueAge}
                    <br />
                  </p>
                )),
              },
            ]
          : []),
      ]}
      additionalContent={
        <CardDisclaimerBase
          disclaimer={t("AgentDeprecatedInsuredCard-disclaimer")}
        />
      }
    />
  );
}
